/* ITT — vendored Three.js loader, CLASSIC route (DEVICE-FIXES 2026-10-31).
   Replaces the Phase 1 loader (22 slices of the r160 ES module,
   reassembled and executed via Blob-module import with a Function
   fallback). That loader passed the local SwiftShader harness but
   NEVER started on the founder's real device (mobile Safari showed
   the fallback message) — harness ≠ device, so the module route is
   abandoned entirely.

   What ships now: three.js r128 UMD — the version the whole house
   codebase already runs — as ONE logical library (603,444 bytes,
   SHA-256 e88777b710dc240de9ae99424dae9b140f708f11ec8bc39440f7fcfae3ffd601,
   extracted byte-for-byte from the verified in-house hero build).
   A single theme-asset upsert cannot carry 603 KB through the
   connector (OS argv limit ≈128 KB per argument), so the source is
   stored as the fewest sequential string slices that fit:
   itt-three-lib-p01.js … p06.js. Each slice is a plain classic
   script that appends its piece of the source to window.__ITT3SRC__.

   Execution, in order:
   1) inject the slices via ordinary <script src> tags, in order
      (same-origin theme assets — the route every browser runs);
   2) join the source and execute it as a classic inline script
      element, which defines the global THREE (UMD build);
   3) if that yields no THREE (e.g. an inline-script CSP refusal),
      run the same source through a Function-scope wrap;
   4) reject — callers degrade to chips + dock + the plain-language
      fallback message, and the CSS cube above is untouched.
   Loading stays lazy: nothing here runs until the visitor opens the
   3D view. Every byte comes from this theme's own assets. */
(function () {
  'use strict';
  var cache = null;

  function assetBase() {
    var s = document.querySelector('script[src*="itt-cube.js"]') ||
            document.querySelector('script[src*="itt-three-loader.js"]');
    if (!s) return '';
    return s.src.replace(/[^/]*(\?.*)?$/, '');
  }

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('three slice failed: ' + url)); };
      document.head.appendChild(s);
    });
  }

  function usable(T) { return !!(T && T.WebGLRenderer && T.Scene && T.CanvasTexture); }

  function execute(src) {
    /* Path 1: classic inline script element — the UMD build attaches
       THREE to the global object. Appending a script element executes
       it synchronously, so the check right after is sound.
       (window.__ITT_FORCE_FN__ is a QA-only hook that skips straight
       to path 2 so the harness can prove the fallback too.) */
    if (!window.__ITT_FORCE_FN__) {
      var s = document.createElement('script');
      s.textContent = src;
      document.head.appendChild(s);
      if (usable(window.THREE)) {
        window.__ITT_THREE_PATH__ = 'script';
        return window.THREE;
      }
    }
    /* Path 2: Function-scope wrap (the UMD still lands on globalThis). */
    try { new Function(src)(); } catch (e) { /* fall through to rejection */ }
    if (usable(window.THREE)) {
      window.__ITT_THREE_PATH__ = 'script-fn';
      return window.THREE;
    }
    throw new Error('three classic load: THREE undefined after execute');
  }

  function load(partsCsv) {
    if (usable(window.THREE)) {
      window.__ITT_THREE_PATH__ = window.__ITT_THREE_PATH__ || 'preloaded';
      return Promise.resolve(window.THREE);
    }
    if (cache) return cache;
    var names = String(partsCsv || '').split(',').filter(function (x) { return x.trim(); });
    if (!names.length) return Promise.reject(new Error('three loader: no slices listed'));
    var base = assetBase();
    window.__ITT3SRC__ = '';
    var chain = Promise.resolve();
    names.forEach(function (n) {
      chain = chain.then(function () { return loadScript(base + n); });
    });
    cache = chain.then(function () {
      var src = window.__ITT3SRC__ || '';
      window.__ITT3SRC__ = '';
      /* the r128 UMD source is 603,444 chars; anything materially
         shorter means a slice went missing — fail loudly into the
         graceful fallback rather than executing a truncated build. */
      if (src.length < 600000) throw new Error('three classic load: source incomplete (' + src.length + ' chars)');
      return execute(src);
    }).catch(function (err) {
      cache = null;
      throw err;
    });
    return cache;
  }

  window.ITTThree = { load: load };
})();
